import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface INewVersionSnackbarProps {
    onReload: () => void;
    seconds: number; 
}

export const NewVersionSnackbar: React.FC<INewVersionSnackbarProps> = ({ onReload, seconds }) => {
    const [count, setCount] = useState<number>(seconds);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (!isVisible) return;
        setCount(seconds); // reset if prop changes / mounts

        const timer = setInterval(() => {
            setCount((c) => {
                if (c <= 1) {
                    // final tick -> trigger reload and stop
                    clearInterval(timer);
                    onReload();
                    return 0;
                }
                return c - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    // restart if seconds changes or visibility changes
    }, [seconds, isVisible, onReload]);

    const handleReload = () => {
        setIsVisible(false);
        onReload();
    };

    if (!isVisible) return null;

    const snackbar = (
        <div className="fixed inset-0 flex justify-center z-50">
            <div className="fixed rounded-sm top-5 bg-gray-800 text-white px-6 py-3 shadow-lg flex items-center gap-4 z-50">
                <span className="text-sm">
                    A new version of the website is available.
                    <span className="ml-2 font-mono">({count})</span>
                </span>
                <button
                    onClick={handleReload}
                    className="bg-white text-gray-900 text-sm px-3 py-1 rounded-sm hover:bg-gray-100 transition"
                >
                    Refresh
                </button>
     
            </div>
        </div>
    );

    return ReactDOM.createPortal(snackbar, document.body);
};